export default {
  author: {
    name: "AllBright",
  },
  title:
    "The go-to hub for transparent conversations around your skincare scepticisms, products that get results without compromise, and all the answers you need to empowered choices.",
  url: "/medik8",
  sys: {
    id: "string",
    firstPublishedAt: 0,
  },
  heroImage: {
    image: {
      title: "string",
      url: "/images/medik8/medik8-article-ad.png",
    },
  },
  description: "",
  topic: "Skintelligent Hub",
};
